export const ScreenshotFrequency = [
    {label:'NONE', value: 0},
    {label:'1X', value: 1},
    {label:'2X', value: 2},
    {label:'3X', value: 3},
]